// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".agreement-pdf[data-v-e883d678] {\n  max-width: 100%;\n  margin: 0 auto;\n}\n.agreement-pdf.align-left[data-v-e883d678] {\n  margin-left: 0;\n}\n.agreement-pdf.align-right[data-v-e883d678] {\n  margin-right: 0;\n}", ""]);
// Exports
module.exports = exports;
